export const reduxKey = '@@CustomboxTemplates';
export const streamId = 'custombox_templates';
